import { useState, useEffect } from 'react';
import styles from './index.module.scss'
import { useNavigate, Link } from 'react-router-dom'
import { getUserProfile } from '../../api/user';
import Logo from '../components/Logo';
import LanguageSwitcher from '../components/LanguageSwitch';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const navigate = useNavigate()
  const { t } = useTranslation();


  useEffect(() => {

    checkLoginStatus();
  }, []);

  // 为用户体验加的重复代码
  const checkLoginStatus = async () => {
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');

      if (!accessToken || !refreshToken) {
        setIsLoggedIn(false);
        setIsLoading(false);
        return false;
      }

      const res = await getUserProfile({});
      if (res.data.status === 200) {
        setIsLoggedIn(true);
        setIsLoading(false);
        return true;
      }
      if (res.status === 401) {
        setIsLoggedIn(false);
        setIsLoading(false);
        return false;
      }

    } catch (error) {
      //console.error('Token verification failed:', error);
      // Token无效，清除localStorage中的token
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      setIsLoggedIn(false);
      setIsLoading(false);
      return false;
    }

    setIsLoading(false);
    return false;
  };

  const handleButtonClick = async () => {
    const loggedIn = await checkLoginStatus();

    if (loggedIn) {
      navigate('/console/home');
    } else {
      navigate('/login');
    }
  };
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (

    <header>
      <div className={styles.navLeft}>
        <div className={styles.logo}>

          <div className={styles.aiOrb}></div>
          <Logo />
        </div>

        <div className={styles.navUl}>
          <Link to="/pricing" className={styles.desktopOnly}>{t('index.header.price')}</Link>
          <div><a href="#about"></a></div>
        </div>
      </div>
      <LanguageSwitcher />
      <button
        className={styles.mobileMenuButton}
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span className={`${styles.hamburger} ${isMobileMenuOpen ? styles.open : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      <div className={`${styles.nav} ${isMobileMenuOpen ? styles.mobileOpen : ''}`}>

        <ul>
          <li>
            <button
              className={`${styles.customLoginButton} ${isHovered ? styles.hovered : ''}`}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={handleButtonClick}
              disabled={isLoading}
            >
              <span className={styles.arrow}>→</span>
              <span className={styles.text}>{isLoading ? t('loading') : isLoggedIn ? t('index.header.console') : t('login_text')}</span>
            </button>
          </li>
          <li className={styles.mobileOnly}>
            <Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)}>
              {t('index.header.price')}
            </Link>
          </li>
        </ul>
      </div>
    </header>
  )
}

export default Header